import { Inject, Injectable } from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot}  from '@angular/router';
import {AppConfigService}  from '../app-config/app-config.service';

@Injectable()
export class AppConfig implements Resolve<any> {
  constructor(@Inject(AppConfigService) private _appConfigService: AppConfigService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      return this._appConfigService.getAppConfig();
  }
}
